import { createContext } from 'react';

export const LOCATIONS = {
  seeAll: 'see all',
  special: 'special',
  pill: 'pill',
  drawer: 'drawer',
  PDP: 'PDP',
  RDP: 'RDP',
  card: 'card',
};

const LocationContext = createContext('');

export default LocationContext;
